import React from "react";
import { MessagesError } from "../../utils/messagesError";

export default function ErrorsComponent({ error }) {
  let messageError = MessagesError(error);
  return <span className="textReject">{messageError}</span>;
}
